export const JOB_DETAIL_VIEW_MODALS = {
  removeFromJob: 'removeFromJob',
  setJobToEmployee: 'setJobToEmployee',
};
